import bookingService from '../../services/booking';
import mixin from '../../mixins/mixin';

export default {
  data() {
    return {
      smallLoading: false,
      exportData: {
        email: '',
        rental_id: 0,
        year: (new Date()).getFullYear(),
      },
    };
  },
  props: {
    rentals: Array,
    email: String,
  },
  mixins: [mixin],
  components: {
    VLoading: require('components/loading/loading.vue'),
  },
  methods: {
    exportBookings() {
      this.exportData.email = this.account.email;
      this.openModal('#export-bookings-modal');
    },
    selectRental(id) {
      this.exportData.rental_id = id;
    },
    exportCsvAndXls() {
      this.smallLoading = true;
      bookingService.exportCsvAndXls(this.exportData, this);
    },
    closeExportModal(modalName) {
      this.closeModal(modalName);
      this.exportData = {
        rental_id: 0,
        year: (new Date()).getFullYear(),
        email: this.account.email,
      };
    },
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/export-bookings/export-bookings.js